// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MonthPicker_wrapper__1jPfI","box":"MonthPicker_box__2ZZCT","span":"MonthPicker_span__1FOST"};